<div class="modal-header">
  <h5 class="modal-title">Impersonation</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  @if (isLoading) {
    <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  } @else {
    <div class="row mb-3">
      <label for="user" class="col-md-4 col-form-label">Select User:</label>
      <div class="col-md-8">
        <eng-typeahead name="user" [data]="userTypeaheadData" [(selectedKey)]="selectedUserId" [ngbAutoFocus]="true" />
      </div>
    </div>

    <div class="row mb-3">
      <label for="client" class="col-md-4 col-form-label">Select Client:</label>
      <div class="col-md-8">
        <eng-typeahead name="client" [data]="clientTypeaheadData" [(selectedKey)]="selectedClientId" />
      </div>
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="isLoading">
    @if (isLoading) {
      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
    }
    Save
  </button>

  <button type="button" class="btn btn-light" (click)="onReset()" [disabled]="isLoading">
    @if (isLoading) {
      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
    }
    Reset
  </button>

  <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isLoading">Cancel</button>
</div>
